import { constants } from "@qgiv/core-js";

/**
 * @public
 * @function getTeamRecipientData
 * @param {object} props
 * @param {boolean} props.isNFP
 * @param {object} props.primaryRegistration
 * @param {Array} props.teams
 * @returns {object}
 */
export const getTeamRecipientData = ({ isNFP, primaryRegistration, teams }) => {
    const {
        ENUMS: { EntityType },
    } = constants;

    const { Team = "", Registration_Role = [] } = primaryRegistration;
    const hasSelectedTeam =
        Team && Number(Registration_Role[0]) === EntityType.TEAM;
    const donationRecipientTeam =
        isNFP && hasSelectedTeam ? EntityType.TEAM : "";

    const primaryTeam = teams.find(({ id }) => `${id}` === Team) || {};
    const teamName = Team.length > 0 ? primaryTeam?.title : "";
    const teamCaptains = primaryTeam?.captains || [];

    return { donationRecipientTeam, teamCaptains, teamName };
};

/**
 * @public
 * @function getClassificationRecipientData
 * @param {object} props
 * @param {Array} props.Classification
 * @param {Array} props.classifications
 * @param {boolean} props.isNFP
 * @param {string} props.donationRecipientTeam
 * @returns {object}
 */
export const getClassificationRecipientData = ({
    Classification,
    classifications,
    isNFP,
    donationRecipientTeam,
}) => {
    const {
        ENUMS: { EntityType },
    } = constants;

    const hasClassification = Classification?.length > 0;
    const donationRecipientClassification =
        isNFP && hasClassification && !donationRecipientTeam
            ? EntityType.CLASSIFICATION
            : "";

    const currentClassification =
        classifications.find(({ id }) => `${id}` === Classification[0]) || {};
    const classificationName =
        Classification.length > 0 ? currentClassification?.title : "";
    const classificationCaptain = currentClassification?.captains || [];

    return {
        classificationCaptain,
        classificationName,
        donationRecipientClassification,
    };
};

/**
 * @public
 * @function getSelectedRecipient
 * @param {object} props
 * @param {Array} props.Classification - Selected classification from registration
 * @param {Array} props.classifications - All classifications from initial state
 * @param {object} props.primaryRegistration - Primary registration from registration
 * @param {Array} props.teams - All teams from initial state
 * @returns {object}
 */
export const getSelectedRecipient = ({
    Classification,
    classifications,
    primaryRegistration,
    teams,
}) => {
    const {
        ENUMS: { EntityType },
    } = constants;

    const { Is_Nfp = false } = primaryRegistration;

    const isNFP = Is_Nfp || false;
    let title = "recipient";
    let captains = [];

    const { donationRecipientTeam, teamCaptains, teamName } =
        getTeamRecipientData({ isNFP, primaryRegistration, teams });

    if (donationRecipientTeam) {
        title = teamName || title;
        captains = teamCaptains;
    }

    const {
        classificationCaptain,
        classificationName,
        donationRecipientClassification,
    } = getClassificationRecipientData({
        Classification,
        classifications,
        isNFP,
        donationRecipientTeam,
    });

    if (donationRecipientClassification) {
        title = classificationName || title;
        captains = classificationCaptain;
    }
    const isNfpEntityType =
        donationRecipientTeam || donationRecipientClassification;
    const entityType = isNfpEntityType || EntityType.FORM;

    const selectedRecipient = { captains, entityType, title };

    return selectedRecipient;
};
